/*
 * @Author: your name
 * @Date: 2021-08-08 23:55:17
 * @LastEditTime: 2022-03-08 21:49:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/main.js
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.less";

import "amfe-flexible/index.js";
// 添加视屏播放插件
import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

import registerApi from "./api";

import installComponent from "./components";

import Auth from "./utils/auth";

Vue.config.productionTip = false;
Vue.prototype.auth = new Auth(router);

Vue.use(Vant);
Vue.use(registerApi);
Vue.use(VideoPlayer);
Vue.use(installComponent);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
